import {camelizeKeys, decamelizeKeys} from 'humps';

export enum PaymentMethodType {
    CARD_DEPOSIT = 'card_deposit',
    CARD_FULL = 'card_full',
    INVOICE_DEPOSIT = 'invoice_deposit',
    INVOICE_FULL = 'invoice_full',
    ACCOUNT = 'account',
    BALANCE = 'balance',
}

export enum SurchargeDisplayMode {
    LINE_ITEM = 'line_item',
    INCLUDED = 'included',
}

export interface Setting {
    enableCardPayments?: boolean;
    enableInvoicePayments?: boolean;
    defaultPaymentMethod?: PaymentMethodType;
    enableSurcharge?: boolean;
    surchargeDisplayMode?: SurchargeDisplayMode;
    surchargeExemption?: boolean;
    allowPayOnAccount?: boolean;
    autoGenerateInvoice?: boolean;
    holdInvoiceIfDeliveryRequired?: boolean;
    holdInvoiceIfVariationsLikely?: boolean;
}

export interface SettingApiResponse {
    enable_card_payments: boolean;
    enable_invoice_payments: boolean;
    default_payment_method: PaymentMethodType;
    enable_surcharge: boolean;
    surcharge_display_mode: SurchargeDisplayMode;
    surcharge_exemption: boolean;
    allow_pay_on_account: boolean;
    auto_generate_invoice: boolean;
    hold_invoice_if_delivery_required: boolean;
    hold_invoice_if_variations_likely: boolean;
}

export const mapToSetting = (rawSetting: SettingApiResponse) => {
    return camelizeKeys(rawSetting) as Setting;
};

export const mapToRawSetting = (setting: Setting) => {
    return decamelizeKeys(setting) as SettingApiResponse;
};
